<div class="card">
  <p-toast/>
  <p-fileupload
    (onError)="onErrorUpload($event)"
    (onSend)="onSend()"
    (onUpload)="onUpload()"
    [multiple]="false"
    accept="application/*"
    maxFileSize="1000000"
    mode="advanced"
    name="file"
    url="{{uploadEndpoint}}"
  >
    <ng-template #empty>
      <div>Drag and drop files here to upload!</div>
    </ng-template>
    <ng-template #content>
      @if (uploadFile) {
        {{ uploadFile.name }} - {{ uploadFile.size }} bytes
      }
    </ng-template>
  </p-fileupload>

  <div *ngIf="isLoading" class="loading-container">
    <p-progressSpinner styleClass="custom-spinner"></p-progressSpinner>
    <p>Caricamento in corso...</p>
  </div>
</div>
